import { yup } from 'utils';

export default yup.object({
  username: yup.string().email().required().label('メールアドレス'),
  password: yup.string().required().label('パスワード'),
});
